import { faSpinner } from "@jewlr/pro-regular-svg-icons/faSpinner"
import { FontAwesomeIcon, Shimmer } from "@jewlr/storybook/core"
import { push } from "connected-react-router"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import styled from "styled-components"

import { history } from "app-store-v2/index"
import { fetchShareEmail } from "app-store-v2/share/actions"
import AcceptPayments from "areas/cart/footer/accept-payments"
import { addToCart } from "areas/product/store/actions"
import ItemEditForm from "components/admin/item-edit-form"
import { IS_JEWLR, IS_PORTAL, jewlr_t } from "helpers/application"

import { ActionButton } from "./components"
import OutOfStockForm from "./out-of-stock-form"
import ShippingInfo from "./shipping-info"

const SendAHintBtn = styled(ActionButton).attrs((props) => ({
  border: {
    _: "1px solid #d9d9d9",
    desktop: `1px solid ${props.theme.colors.neutral}`,
  },
  fontWeight: { _: 500, desktop: 300 },
}))``

const InternalWizardActions = ({
  addToCart,
  adminMode,
  header,
  isAddingToCart,
  lid,
  olid,
  openShareModal,
  orderNumber,
  outOfStockRef,
  prefStore,
}) => {
  if (!header) return null
  const cartStr = jewlr_t("Cart")

  if (!prefStore) {
    return (
      <>
        <Shimmer height="48px" mb="20px" width="100%" />
        {IS_PORTAL() && <AcceptPayments />}
        <ShippingInfo />
        {IS_JEWLR() && <Shimmer height="48px" width="100%" />}
      </>
    )
  }

  let hdrActions = []

  if (header.product_out_of_stock) {
    return (
      <>
        <OutOfStockForm key="out-of-stock-form" outOfStockRef={outOfStockRef} />
        <ShippingInfo />
      </>
    )
  } else {
    // add to cart button
    if (header.params_olid_present) {
      hdrActions.push(<ItemEditForm key="item-edit-form" />)
    } else {
      hdrActions.push(
        <ActionButton
          className="js-add-cart"
          data-cy="product-wizard-add-to-cart-btn"
          disabled={isAddingToCart}
          fontWeight={{ _: 700, desktop: 300 }}
          key="add-to-cart-cta"
          mb="20px"
          onClick={(e) => addToCart(e, isAddingToCart)}
          primary
          rel="nofollow"
          type="submit"
        >
          {header.params_olid_present
            ? "Update Order"
            : lid
            ? isAddingToCart
              ? `Updating ${cartStr}...`
              : `Update ${cartStr}`
            : isAddingToCart
            ? `Adding to ${cartStr}...`
            : `Add to ${cartStr}`}
          {isAddingToCart ? <span>&nbsp;</span> : null}
          {isAddingToCart ? <FontAwesomeIcon icon={faSpinner} spin /> : null}
        </ActionButton>
      )
    }
  }

  // not sure what this represents. i think its when its editing from the cart
  if (header.params_olid_present) {
    if (adminMode) {
      hdrActions.push(
        <ActionButton
          key="cancel-change-btn"
          onClick={() => (window.location = `${header.form_url}?cancel=true`)}
          outline="neutral"
          rel="nofollow"
        >
          Cancel Change
        </ActionButton>
      )
    } else {
      hdrActions.push(
        <Link
          data-lc="wizard-actions"
          key="cancel-change-btn"
          outline="neutral"
          rel="nofollow"
          to={`/order/change?order_number=${orderNumber}&lii=${olid}`}
        >
          <ActionButton>Cancel Change</ActionButton>
        </Link>
      )
    }
  } else {
    if (IS_PORTAL()) {
      hdrActions.push(<AcceptPayments key="accept-payments" />)
    }

    hdrActions.push(<ShippingInfo key="shipping-info" />)

    if (IS_JEWLR()) {
      hdrActions.push(
        <SendAHintBtn
          data-cy="product-wizard-send-a-hint-btn"
          key="send-a-hint-btn"
          onClick={() => openShareModal("product")}
        >
          Send a Hint
        </SendAHintBtn>
      )
    }
  }

  return hdrActions
}

const mapStateToProps = (state) => {
  return {
    adminMode: state.wizard.adminMode,
    header: state.wizard.header,
    isAddingToCart: state.wizardUI.isAddingToCart,
    lid: state.wizardUI.lid,
    olid: state.wizard.olid,
    orderNumber: state.wizard.orderNumber,
    prefStore: state.wizardUI.prefStore,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (e, isAddingToCart) => {
      e.preventDefault()
      if (!isAddingToCart) {
        dispatch(addToCart())
      }
    },
    openShareModal: () => {
      dispatch(fetchShareEmail())
      dispatch(
        push(
          `${history.location.pathname}${history.location.search}#share-modal`
        )
      )
    },
  }
}

InternalWizardActions.propTypes = {
  addToCart: PropTypes.func,
  adminMode: PropTypes.bool,
  header: PropTypes.object,
  isAddingToCart: PropTypes.bool,
  lid: PropTypes.string,
  olid: PropTypes.any,
  openShareModal: PropTypes.func,
  orderNumber: PropTypes.string,
  outOfStockRef: PropTypes.object,
  prefStore: PropTypes.bool,
}

const WizardActions = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalWizardActions)

export default connect(mapStateToProps)(WizardActions)
